'use strict';

const toastMessageHelper = require('../utils/toastMessageHelper');

module.exports = function () {
    var initialHeight = window.visualViewport.height;
    /**
     * Updates the position of the global toast notification
     * based on the mobile keyboard visibility and input focus state.
     *
     * If the newsletter input is focused and the virtual keyboard is open,
     * the notification is vertically centered. Otherwise, it is placed
     * at the default top position.
     *
     * @function updateToastPosition
     * @returns {void}
     */
    function updateToastPosition() {
        var isInputFocused = $('#newsletter-form-input').is(':focus');

        // keyboard open
        if (isInputFocused && window.visualViewport.height < initialHeight) {
            $('#globalNotification').css({
                top: '50%'
            });
        } else {
            // keyboard closed
            $('#globalNotification').css({
                top: '161px'
            });
        }
    }

    // keyboard open/close resize
    if (window.visualViewport) {
        window.visualViewport.addEventListener('resize', updateToastPosition);
    }

    var emailField = $('#newsletter-form-input');
    var emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+\.[a-zA-Z]{2,}$/;

    $('#news-letter-form').on('submit', function (e) {
        e.preventDefault();
        var emailId = emailField.val().trim();
        if (!emailId || !emailRegex.test(emailId)) {
            emailField.addClass('is-invalid');
            if (!emailId) {
                $('.enter-email-error').removeClass('d-none');
            } else {
                $('.valid-email-error').removeClass('d-none');
            }
            return;
        }
        emailField.removeClass('is-invalid');

        var actionURL = $(this).attr('action');
        var formData = $(this).serialize();

        $.ajax({
            url: actionURL,
            type: 'post',
            data: formData,
            success: function (response) {
                if (response.success) {
                    toastMessageHelper.showNotification(response.message);
                } else {
                    toastMessageHelper.showNotification(response.message);
                }
                $('#newsletter-form-input').val('');
            }
        });
    });

    emailField.on('input', function () {
        $(this).removeClass('is-invalid');
        $('.enter-email-error, .valid-email-error').addClass('d-none');

        var cleaned = $(this).val().replace(/[^a-zA-Z0-9@.]/g, '');
        $(this).val(cleaned);
        if ($(this).val() === '' || !emailRegex.test($(this).val())) {
            if ($(this).val() === '') {
                $(this).addClass('is-invalid');
                $('.enter-email-error').removeClass('d-none');
            } else {
                $(this).addClass('is-invalid');
                $('.valid-email-error').removeClass('d-none');
            }
            return;
        }

        if (emailRegex.test(cleaned)) {
            emailField.removeClass('is-invalid');
            $('.enter-email-error, .valid-email-error').addClass('d-none');
        }
    });

    /**
     * Checks if the user has scrolled past 3 * window height, and
     * if so, shows the back to top button.
     */
    function backToTop() {
        var scrollTop = window.pageYOffset;
        var windowHeight = window.visualViewport.height;
        if (scrollTop > 1.5 * windowHeight) {
            $('.back-to-top').removeClass('d-none').addClass('d-flex');
        } else {
            $('.back-to-top').addClass('d-none').removeClass('d-flex');
        }
    }

    $(window).on('scroll', function () {
        backToTop();
    });
    backToTop();

    $('.back-to-top').on('click', function () {
        $('html, body').animate({ scrollTop: 0 }, 500);
    });

    $('.best-seller').filter('a').attr({ href: '#', role: 'button' });
    $(document).on('click', '.best-seller', function (e) {
        e.preventDefault();
        e.stopPropagation();
    });

    $('.loyaltyprogram, .loyaltypoints, .loyalityrewardenrolmentbutton, .header-loyaltypoints').on('click', function (e) {
        var customerType = $('.session-customer-type').val();
        if (customerType === 'International') {
            e.preventDefault();
            var message = $('.loyalty-enrollment-restriction-msg').val();
            toastMessageHelper.showNotification(message);
        }
    });
};
